// Function to filter products based on a query string
function filterProductList(productList, queryString) {
    if (!productList || !queryString) return;

    // Format the query to lowercase and trim it
    const searchQuery = queryString.toLowerCase().trim();

    // Get the filtered products based on the search query
    const filteredProductList = productList.filter((product) => {
        // Get the product name and description in lowercase
        const productName = product.name.toLowerCase();
        const productDescription = product.description.toLowerCase();

        // Check if the product name or description includes the search query
        return (
            productName.includes(searchQuery) ||
            productDescription.includes(searchQuery)
        );
    });
    return filteredProductList;
}

export default filterProductList;
